// @flow
import $ from 'jquery';
import flashMessage from '../utils/flashMessage';

export default class ApiClient {
  ajax = $.ajax;
  errorHandler: Function;

  constructor(errorHandler: Function = this.defaultErrorHandler) {
    this.errorHandler = errorHandler;
  }

  defaultErrorHandler = (jqXHR: any) =>
    flashMessage(jqXHR.responseText, 'danger');
}
